<template>
  <div>
    <v-list subheader>
      <v-item-group>
        <v-expansion-panels focusable>
          <v-item class="my-1">
            <CardItemsExpandComponents :is-ready="!$store.getters.isLoading">
              <template v-slot:icon>
                <v-badge bordered :content="totalItems" left>
                  <v-icon color="primary" v-text="'mdi-cart-outline'" />
                </v-badge>
              </template>
              <template v-slot:body>
                <v-container fluid fill-height pa-0 ma-0>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <span
                        class="title-card-item-component"
                        v-text="$t('checkout.cart_items')"
                      />
                    </v-col>
                    <v-col cols="12" class="pt-1">
                      <span
                        class="subtitle-card-item-component"
                        v-text="$t('general.details')"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:expantion>
                <div v-for="(item, index) in productsInCart" :key="item.id">
                  <v-list-item class="test_blue">
                    <v-list-item-content @click="showAction = -1">
                      <v-container fluid pa-0 ma-0>
                        <v-row
                          no-gutters
                          justify="space-between"
                          align="center"
                        >
                          <v-col>
                            <div>
                              <span class="product-name pr-0 pr-sm-3">
                                {{ formatProductName(item) }}
                              </span>
                            </div>
                            <!-- Pickup date information for cart items -->
                            <div
                              v-if="item.productRequiredPickupDateFrom"
                              class="py-1 mt-1"
                            >
                              <v-chip color="info" x-small class="mr-1">
                                <v-icon x-small left>mdi-calendar-range</v-icon>
                                Pickup:
                                {{
                                  formatDate(item.productRequiredPickupDateFrom)
                                }}
                                -
                                {{
                                  formatDate(item.productRequiredPickupDateTo)
                                }}
                              </v-chip>
                            </div>
                            <div class="py-1">
                              <span
                                v-if="item.productDiscount"
                                class="product-variation old-price pr-5"
                                v-text="
                                  $appFormatters.formatMoney(
                                    item.productSubTotal
                                  )
                                "
                              />
                              <GroupedAddonsList
                                :grouped-addons="item.groupedAddons"
                                :format-money="$appFormatters.formatMoney"
                              />
                              <v-row
                                no-gutters
                                justify="start"
                                class="test_blue text-right mt-3"
                              >
                                <span
                                  class="product-price"
                                  v-text="
                                    $appFormatters.formatMoney(
                                      item.itemTotalPrice
                                    )
                                  "
                                />
                              </v-row>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-container fluid>
                        <v-row no-gutters justify="end">
                          <v-col cols="12" class="test_pink">
                            <!-- Quantity display or actions -->
                            <v-row
                              v-if="showAction !== index"
                              no-gutters
                              justify="end"
                              class="test_blue"
                            >
                              <v-chip
                                class="mb-2"
                                color="light-grey"
                                label
                                text-color="primary"
                                pill
                                outlined
                                style="font-size: 16px; font-weight: bold"
                                @click="showAction = index"
                              >
                                {{ item.quantity }}
                              </v-chip>
                            </v-row>
                            <QuantitySelector
                              v-if="showAction === index"
                              class="mr-2"
                              :quantity="item.quantity"
                              :min="1"
                              @decrement="decrementItem(item.id)"
                              @increment="incrementItem(item.id, item.quantity)"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index < productsInCart.length - 1"
                    class="mb-2 ml-4 mr-4"
                  />
                </div>
              </template>
            </CardItemsExpandComponents>
          </v-item>
        </v-expansion-panels>
        <v-item class="my-1">
          <v-btn
            text
            :is-ready="!$store.getters.isLoading"
            :hide-actions="true"
            @click="
              $router.push({
                name: 'Discovery',
              })
            "
          >
            <v-icon left>mdi-plus</v-icon>
            {{ $t("checkout.add_more_items") }}
          </v-btn>
        </v-item>
      </v-item-group>
    </v-list>
  </div>
</template>

<script>
import { GroupedAddonsList } from "@/views/front/discovery/components/subcomponents";
import QuantitySelector from "@/views/front/checkout/components/QuantitySelector.vue";

export default {
  name: "CartItems",
  components: { QuantitySelector, GroupedAddonsList },
  data: () => ({
    totalItems: null,
    productsInCart: [],
    comments: null,
    showAction: -1,
    dialog: false,
    productdetails: {},
  }),
  watch: {
    comments: function () {
      this.$emit("input", this.comments);
      const self = this;
      self.$store.dispatch("checkout/setComment", this.comments);
    },
    "$store.getters.cartDetails": function () {
      if (this.$store.getters.cartDetails) {
        this.totalItems = this.$store.getters.cartDetails.totalItems;
        this.productsInCart = this.$store.getters.cartDetails.items;
        this.$checkoutValidator.minOrderAmount();
      }
    },
  },
  created() {
    this.comments = this.$store.getters.checkoutComment;
  },
  beforeMount() {
    this.$store.dispatch("cart/setLoad");
  },
  methods: {
    selectProduct: function (item) {
      const self = this;
      const data = this.$store.getters.storeMenu;
      console.log(data);
      console.log("item", item);
      self.productdetails = item;
      self.dialog = true;
    },
    formatProductName(item) {
      return item.productVariationName
        ? `${item.productName} ( ${item.productVariationName} )`
        : item.productName;
    },
    formatDate: function (dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("da-DK", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    addonsList: function (addosn) {
      let list = [];
      addosn.map((item) => {
        list.push(item.addonName);
      });
      return list.toString();
    },
    removeItem: async function (item, qty) {
      const self = this;
      self.$store.dispatch("loading/start");
      const { value: result } = await Swal.fire({
        title: self.$t("general.remove_item_cart_question_title", {
          qty: qty,
          productname: item.productName,
        }),
        text: self.$t("general.remove_item_cart_description"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: self.$t("general.cancel"),
        confirmButtonText: self.$t("general.confirm"),
        allowOutsideClick: false,
      });

      if (result) {
        const { data } = await axios.delete(
          "/app/orders/shopping/cart/" + self.$store.getters.guestSessionId,
          {
            params: {
              itemQty: qty,
              itemId: item.id,
            },
          }
        );
        Toast.fire({
          icon: "success",
          title: data.message,
        });
        if (data.data.totalItems > 0) {
          self.$store.dispatch("cart/setLoad");
        } else {
          self.$store.dispatch("guest/removeSessionId");
          self.$store.dispatch("checkout/setTotal", 0);
          self.$store.dispatch("cart/deleteDetails");

          setTimeout(() => {
            this.$router.push({ name: "Discovery" });
          }, 200);
        }
      }
      self.$store.dispatch("loading/done");
    },
    decrementItem: async function (id) {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await axios.delete(
        "/app/orders/shopping/cart/" + self.$store.getters.guestSessionId,
        {
          params: {
            itemQty: 1,
            itemId: id,
          },
        }
      );
      Toast.fire({
        icon: "success",
        title: data.message,
      });

      self.$store.dispatch("cart/setLoad");
      if (data.data.totalItems <= 0) {
        self.$store.dispatch("guest/removeSessionId");
        self.$store.dispatch("checkout/setTotal", 0);
        setTimeout(() => {
          this.$router.push({ name: "Discovery" });
        }, 200);
      }

      self.$store.dispatch("loading/done");
    },
    incrementItem: async function (id, qty) {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await axios.patch(
        "/app/orders/shopping/cart/" + self.$store.getters.guestSessionId,
        {
          itemQty: parseInt(qty) + 1,
          itemId: id,
        }
      );
      Toast.fire({
        icon: "success",
        title: data.message,
      });

      self.$store.dispatch("cart/setLoad");

      self.$store.dispatch("loading/done");
    },
  },
};
</script>
<style lang="scss" scoped>
.comment-container {
  background-color: gray;
}
.product-name {
  font-size: 1.2rem;
  font-weight: 700;
}
.product-variation {
  font-size: 1rem;
}
.product-description {
  font-size: 0.9rem;
}
.product-price {
  font-size: 1.2rem;
  color: var(--v-primary-base) !important;
}
.product-addons-list-container {
  border-radius: 5px;
}
.product-addons-list {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
  //padding: 0;
  //margin: 0;
  margin-left: 10px;
}
.contentItem {
  align-items: start !important;
  justify-content: right !important;
}
.custom-chip {
  font-size: 16px; /* Increase font size */
}
.quantity-selector {
  max-width: 150px;
  margin-bottom: 4px;
}
</style>
